import React from 'react';
import Specifications from '../../../overrides/venia-ui/components/ProductFullDetail/Specifications/specifications';
import defaultClasses from './tearsheetPDF.module.css';

var SpecificationsPDF = function SpecificationsPDF(_ref) {
  var productDetails = _ref.productDetails,
      customAttributes = _ref.customAttributes,
      weight = _ref.weight,
      disabledValuesMap = _ref.disabledValuesMap;
  return React.createElement(React.Fragment, null, React.createElement("h5", {
    className: defaultClasses.bottomBorder
  }, "Specifications"), React.createElement(Specifications, {
    productDetails: productDetails,
    customAttributes: customAttributes,
    weight: weight,
    disabledValuesMap: disabledValuesMap,
    isPDF: true
  }));
};

export default SpecificationsPDF;